import CaseFolders from "../CaseFolders";
import Notifications from "../Notifications";
import Overview from "../Overview";
import PaymentHistory from "../PaymentHistory";
import Requests from "../Requests";
import Settings from "../Settings";
import CreateCase from "../internals/case-folder/CreateCase";
import FileAsDefendant from "../internals/case-folder/FileAsDefendant";
import FileAsThirdParty from "../internals/case-folder/FileAsThirdParty";
import FileDefenceProcess from "../internals/case-folder/FileDefenceProcess";
import FileNewProcess from "../internals/case-folder/FileNewProcess";
import SearchResult from "../internals/case-folder/SearchResult";
import ViewCaseFolder from "../internals/case-folder/ViewCaseFolder";

export const PrivateIndividualRoute = [
  {
    title: "Overview",
    path: "/private-individual/overview",
    component: Overview,
  },
  {
    title: "Case Folders",
    path: "/private-individual/case-folders",
    component: CaseFolders,
  },
  {
    title: "Create Case",
    path: "/private-individual/case-folders/create",
    component: CreateCase,
  },
  {
    title: "View Case Folder",
    path: "/private-individual/case-folders/view",
    component: ViewCaseFolder,
  },
  {
    title: "Create Case",
    path: "/private-individual/case-folders/create",
    component: CreateCase,
  },
  {
    title: "Create Case",
    path: "/private-individual/case-folders/view/file-new-process",
    component: FileNewProcess,
  },
  {
    title: "File Defence Process",
    path: "/private-individual/case-folders/view/file-defence-process",
    component: FileDefenceProcess,
  },
  {
    title: "File Defence Process",
    path: "/private-individual/case-folders/file-defendant-process",
    component: FileAsDefendant,
  },
  {
    title: "File Defence Process",
    path: "/private-individual/case-folders/file-third-party-process",
    component: FileAsThirdParty,
  },
  {
    title: "Create Case",
    path: "/private-individual/case-folders/search-result",
    component: SearchResult,
  },
  {
    title: "Request",
    path: "/private-individual/request",
    component: Requests,
  },
  {
    title: "Payment history",
    path: "/private-individual/payment-history",
    component: PaymentHistory,
  },
  {
    title: "Notification",
    path: "/private-individual/notification",
    component: Notifications,
  },
  {
    title: "Setting",
    path: "/private-individual/setting",
    component: Settings,
  },
];
